<div class="flex flex-col">
  <div class="flex flex-col gap-2 pt-2" *ngIf="editable">
    <span class="font-semibold">Select Required Documents to Upload</span>
    <div class="flex flex-row justify-start items-center gap-4 portal-field-grid">
      <mat-form-field>
        <mat-label>Required Documents</mat-label>
        <mat-select [formControl]="selectedTypes" multiple>
          <mat-option *ngFor="let type of documentTypes" [value]="type">{{type.type}}</mat-option>
        </mat-select>
      </mat-form-field>

      <input type="file" style="display: none;" accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.pdf,.doc,.docx,.txt" (change)="uploadDocument($event)" #fileUpload />
      <div class="flex flex-row gap-2 items-center">
        <div class="file-upload">
          <button mat-button color="primary" class="upload-btn" (click)="fileUpload.click()" [disabled]="selectedTypes.value?.length === 0" matTooltip="Upload Document" matTooltipShowDelay="500"
            matTooltipHideDelay="200">
            Upload
            <mat-icon>upload</mat-icon>
          </button>
        </div>

        <mat-checkbox [(ngModel)]="enableUserDownload">User Can Download</mat-checkbox>

      </div>

      <div class="flex flex-col" *ngIf="uploading">
        <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
        <span>Uploading: {{ uploadProgress }}%</span>
      </div>
      <div class="flex flex-col" *ngIf="downloading">
        <mat-progress-bar mode="determinate" [value]="downloadProgress"></mat-progress-bar>
        <span>Downloading: {{ downloadProgress }}%</span>
      </div>

      <button class="ml-auto" type="button" mat-button color="primary" (click)="getDocuments(!includeArchived)">{{ includeArchived? 'Hide Archived' : 'Show Archived' }}</button>
    </div>
  </div>

  <mat-table [dataSource]="documentSource" matSort #documentSort="matSort" aria-describedby="documents" class="mat-elevation-z8 portal-responsive-table">
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">Name</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let document">
        <span class="mobile-label">Name</span>
        <button type="button" class="portal-text-action" (click)="downloadDocument(document)">{{ document.name }}</button>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="types">
      <mat-header-cell *matHeaderCellDef>Types</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let document">
        <span class="mobile-label">Types</span>
        <div class="flex flex-col">
          <div *ngFor="let type of document.types">
            <span>{{ type.type }}</span>
          </div>
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="dateCreated">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">Uploaded</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let document">
        <span class="mobile-label">Uploaded</span>
        {{ document.dateCreated | date }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="archived">
      <mat-header-cell *matHeaderCellDef>Archived</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let document">
        <span class="mobile-label">Archived</span>
        <div class="flex flex-col">
          <span>{{ document.archived? 'Yes' : 'No' }}</span>
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="actions" *ngIf="editable">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let document">
        <div class="flex flex-row justify-start items-center portal-actions">
          <button *ngIf="editable" type="button" mat-icon-button [color]="document.archived? 'primary' : 'warn'" (click)="archiveDocument(document, !document.archived)"
            [matTooltip]="document.archived? 'Un-Archive Document' : 'Archive Document'" matTooltipShowDelay="500" matTooltipHideDelay="200">
            <mat-icon *ngIf="!document.archived">archive</mat-icon>
            <mat-icon *ngIf="document.archived">unarchive</mat-icon>
          </button>
          <button *ngIf="!locked && editable" type="button" mat-icon-button color="warn" (click)="deleteDocument(document)" matTooltip="Delete Document" matTooltipShowDelay="500"
            matTooltipHideDelay="200">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="documentColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: documentColumns" class="" [ngClass]="row.archived? 'portal-archived' : ''"></mat-row>
  </mat-table>
  <mat-paginator *ngIf="documents.length > 5" [pageSizeOptions]="[5, 10, 20]" #documentPaginator="matPaginator">
  </mat-paginator>
</div>
